import React from "react";
import "./styles/Account.css";
import AuthUserContext from "./AuthUserContext";
import { PasswordForgetForm } from "./PasswordForget";
import PasswordChangeForm from "./PasswordChange";
import withAuthorization from "./withAuthorization";
import Payment from "./Payment";
import URL from "../constants/url";

import { db, firestore } from "../firebase/firebase";
import { firebase } from "../firebase";
const axios = require("axios");

const AccountInfo = lol => {
  return (
    <div>
      {/* {console.log(lol)} */}
      <div className="baslik">
        <i className="material-icons">account_box</i>
        <h4>Account Info</h4>
      </div>
      <div style={{ marginLeft: "20px" }}>
        <p>Email: {lol.auth.email}</p>
      </div>
    </div>
  );
};

// const Balance = props => {
class Balance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      balance: null
    };
  }

  componentDidMount() {
    // console.log(this.props.auth.uid);
    // firestore
    //   .collection("users")
    //   .doc(this.props.auth.uid)
    //   .onSnapshot(snapshot => {
    //     // // console.log(snapshot.data().balance);
    //     this.setState({
    //       balance: snapshot.data().balance
    //     });
    //   });
    let query = {};
    query["user"] = this.props.auth.uid;
    axios
      .post(`${URL}/balance`, query)
      .then(response => {
        // console.log(response.data.balance);
        this.setState({ balance: response.data.balance / 100 });
      });
  }

  render() {
    return (
      <div>
        <div className="baslik">
          <i className="material-icons">account_balance</i>
          <h4>Balance</h4>
        </div>
        {/* <div className="priceCard"> */}
        <h2 style={{ marginLeft: "20px" }}>{`$${this.state.balance}`}</h2>
        {/* </div> */}
      </div>
    );
  }
}

class AccountPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      balance: 0
    };
  }
  componentDidMount() {
    firestore.collection("users").doc();
  }
  render() {
    return (
      // it gets access to the authenticated user object via React’s
      // context by using the Consumer component
      <AuthUserContext.Consumer>
        {/* authUser is accessible because its created by the Provider (Context
  API)-Higher order component */}
        {authUser => (
          <div id="accountContainer">
            {/* <h1>Account: {authUser.email}</h1> */}
            <AccountInfo auth={authUser} />
            {/* <PasswordForgetForm /> */}
            <PasswordChangeForm uid={this.props.aa.uid} />
            <br />
            {/* <Loadable active={false} spinner text="Loading your content..."> */}
            <Balance auth={authUser} />
            {/* {console.log(this.props.aa.email)} */}
            <Payment uid={this.props.aa.uid} email={this.props.aa.email} />
            {/* </Loadable> */}
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

// checks if the authUser object is not null
const authCondition = authUser => !!authUser;

// export default withAuthorization(authCondition)(HomePage);
export default withAuthorization(authCondition)(AccountPage);
